// Getters
export const opportunities = (state) => {
  return state.opportunities.data || []
}
export const opportunitiesLoading = (state) => {
  return state.opportunities.loading
}
export const opportunitiesLastUpdate = (state) => {
  return state.opportunities.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}
